export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6522.d2fded97.jpg";